export { default } from './request-equipment-service-description';
